import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import React from "react";
import { useTranslation } from "react-i18next";

export const NoRevenuesChart = ({ state }) => {

    const [data,setData] = useState({});
    const { t, i18n } = useTranslation("common");

    
    useEffect(() => {
        setData({});

        if(state){
            setData({
                labels : state?.timeseries?.labels,
                dataUnit: t("statistic.views"),
                datasets: [
                    {
                        label: t("statistic.views"),
                        numberFormat: "integer",
                        color: "#eb6459",
                        borderWidth: 2,
                        borderColor: "#eb6459",
                        lineTension: 0,
                        fill: true,
                        dash: 0,
                        pointRadius: 0,
                        lineTension: 0.4,
                        backgroundColor: "rgba(235, 100, 89, 0.15)",
                        pointBorderColor: "transparent",
                        pointBackgroundColor: "transparent",
                        pointHoverBackgroundColor: "#fff",
                        pointHoverBorderColor: "#eb6459",
                        pointBorderWidth: 2,
                        pointHoverRadius: 4,
                        pointHoverBorderWidth: 2,
                        pointHitRadius: 4,
                        data: state?.timeseries?.series?.view_sum?.length > 0 ? state?.timeseries?.series?.view_sum : [],
                    },
                ],
            })
        }

    },[state])

    var viewNumberFormat = new Intl.NumberFormat('en-US', {
        maximumSignificantDigits: 2
    });

    return (
        <React.Fragment>
            {data && <Line
            className="ecommerce-line-s4"
            data={data}
            options={{
                legend: {
                    display: false,
                },
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return data["labels"][tooltipItem[0]["index"]];
                        },
                        label: function (tooltipItem, data) {
                            return `${data.datasets[tooltipItem.datasetIndex].label}: ${viewNumberFormat.format(tooltipItem.yLabel)}`;
                        },
                    },
                    backgroundColor: "#1c2b46",
                    titleFontSize: 13,
                    titleFontColor: "#fff",
                    titleMarginBottom: 6,
                    bodyFontColor: "#fff",
                    bodyFontSize: 12,
                    bodySpacing: 4,
                    yPadding: 10,
                    xPadding: 10,
                    footerMarginTop: 0,
                    displayColors: false,
                },
                scales: {
                    yAxes: [
                        {
                            display: true,
                            position: "right" ,
                            ticks: {
                                beginAtZero: true,
                                fontSize: 11,
                                fontColor: "#eb6459",
                                padding: 10,
                                callback: function (value) {
                                    return viewNumberFormat.format(value);
                                },
                                min: 0,
                                stepSize: 9000,
                            },
                            gridLines: {
                                color: "rgba(82, 100, 132, 0.2)",
                                tickMarkLength: 0,
                                zeroLineColor: "rgba(82, 100, 132, 0.2)",
                            },
                        },
                    ],
                    xAxes: [
                        {
                            display: true,
                            stacked: false,
                            ticks: {
                                fontSize: 9,
                                fontColor: "#9eaecf",
                                source: "auto",
                                padding: 10,
                            },
                            gridLines: {
                                color: "transparent",
                                tickMarkLength: 0,
                                zeroLineColor: "transparent",
                            },
                        },
                    ],
                },
            }}
        />}
        </React.Fragment>
    
    );
};